<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="!$route.meta.nokeepAlive"></router-view>
    </keep-alive>
    <router-view v-if="$route.meta.nokeepAlive"></router-view>
    <v-header :tabActiveIndex="0"></v-header>
    <v-chater></v-chater>
  </div>
</template>
<script type="text/ecmascript-6">
import { mapMutations, mapGetters, mapState } from "vuex";
import { Header, Toast } from "mint-ui";
import vHeader from "./components/header/Header";
import vChater from "./components/chater/Chater";
export default {
  name: "app",
  data() {
    return {
      tabActiveIndex: 0
    };
  },
  created() {},
  methods: {
    ...mapMutations(["COMPANYS"]),
    loadData() {
      this.$axios
        .reqCompanyInfo({
          params: {}
        })
        .then(res => {
          if (res.data.status === 200) {
            //localStorage.setItem("company", JSON.stringify(res.data));
            this.COMPANYS(res.data.data);
          }
        });
    }
  },
  mounted() {
    this.loadData();
  },
  components: {
    vHeader,
    vChater
  },
  computed: {
    ...mapState(["companys"]),
    ...mapGetters(["companys"])
  }
};

function includeMask() {
  var html = "";
  html += '<div class="mask flexcontainer" id="all_mask">';
  html += '<div class="mask-box">';
  html += '<div class="mask-pic">';
  html += "<i></i>";
  html += "</div>";
  html += "<span>为了更好的体验，请将手机/平板竖过来</span>";
  html += "</div>";
  html += "</div>";
  document.querySelector("body").insertAdjacentHTML("beforeend", html);
}
includeMask();

function IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = new Array(
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPad",
    "iPod"
  );
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}
</script>

<style>
@import "./assets/css/fonts/iconfont.css";
@import "./assets/css/fonts/animate.css";

#app {
  width: 100%;
  height: 100%;
  position: relative;
  margin: 0;
  padding: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// App.vue?95a3d14c